import { getStore } from "app/store/store"
import { IWeather } from "schedule/model"
import { scheduleRPO } from "schedule/repository"

export const getAvailableWeathers = (): Promise<IWeather[]> => scheduleRPO.getAvailableWeathers()

export const getAvailableWeathersInStore = (): IWeather[] => getStore().getState().schedule.weathers
